// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"MarginGenericSolution-module--wrapper--3nvoq"};